import { memo } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import get from "lodash/get";
import { FormattedMessage } from "react-intl";
import Badge from "app/pages/.shared/Badge";
import Timer from "app/pages/.shared/Timer";
import "./HotelPhotoSection.scss";

const PhotoCarousel = loadable(() => import("app/pages/.shared/PhotoCarousel.jsx"));
const SlideShow = loadable(() => import("app/pages/.shared/Slideshow/SlideShow.jsx"));

const HotelPhotoSection = ({
	isMobile,
	printMode,
	photos = [],
	slideshow = {},
	closeSlideshow,
	showTimerOnProductPicture,
	hotelExpiration,
	resolution,
}) => {
	return (
		<div className="hotel-photo-section">
			{isMobile && !printMode && get(photos, "length") > 0 && (
				<PhotoCarousel photos={photos} resolution={resolution} />
			)}
			{!isMobile && !printMode && slideshow.isSlideshowOpened && (
				<SlideShow
					isOpened={slideshow.isSlideshowOpened}
					close={closeSlideshow}
					photos={photos}
				/>
			)}
			{showTimerOnProductPicture && (
				<div className="hotel-photo-section__badge">
					<Badge>
						<Timer
							hour={hotelExpiration?.hour}
							day={hotelExpiration?.day}
							suffix={<FormattedMessage id="timer.left.label" />}
						/>
					</Badge>
				</div>
			)}
		</div>
	);
};

HotelPhotoSection.propTypes = {
	isMobile: PropTypes.bool,
	printMode: PropTypes.bool,
	photos: PropTypes.array,
	slideshow: PropTypes.object,
	closeSlideshow: PropTypes.func,
	showTimerOnProductPicture: PropTypes.bool,
	hotelExpiration: PropTypes.object,
	resolution: PropTypes.string,
};

export default memo(HotelPhotoSection);
